import ApiCore from '../api-core'
import { ACTIVE_BASE_REST } from '../constants'

export default class SystemSettingMap extends ApiCore {
  constructor(store) {
    super(store, `${ACTIVE_BASE_REST}/setting/map`)
  }

  get(showProgress) {
    return this._request({
      method: 'GET',
      showProgress
    })
  }

  update(model, showProgress) {
    return this._request({
      method: 'PUT',
      body: model,
      showProgress
    })
  }
}
